import { useCallback } from 'react';
import { Button, Colors } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';
import { useClearAllFilters } from 'hooks/filterToolbar/useClearFilters';
import { useResetMapSelections } from 'hooks/projectMap/useResetMapState';
import { useDashboardGroupId, useDashboard } from 'state/dashboard';

const buttonWrapperStyle = {
  color: Colors.Tangerine900,
};

const buttonStyle = {
  padding: '0',
  height: 'auto',
};

const ClearAllFiltersButton = () => {
  const [dashboardGroupId] = useDashboardGroupId();
  const { clearGroup } = useDashboard();
  const { clearAllFilters } = useClearAllFilters();
  const { resetAllMapSelections } = useResetMapSelections();

  const globalClearAll = useCallback(() => {
    resetAllMapSelections();
    if (Number(dashboardGroupId) > 0) {
      clearGroup();
    }
    clearAllFilters();
  }, [clearGroup, clearAllFilters, dashboardGroupId]);

  return (
    <FlexRow sx={buttonWrapperStyle}>
      <Button variant="unstyled" onClick={globalClearAll} sx={buttonStyle}>
        Clear All
      </Button>
    </FlexRow>
  );
};

export default ClearAllFiltersButton;
